import { useEffect } from "react";
import map from "lodash/map";
// import featureMapping from "smart-components";

const usePrefetchComponents = pageComponents => {
  useEffect(() => {
    map(pageComponents, comp => {
      // return featureMapping[comp.name]._ctor();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(pageComponents)]);
};
export default usePrefetchComponents;
